//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import formatedTextInput from '@/components/formatedTextInput';

export default {
    name: 'Calculator',
    components: {
        'formated-text-input': formatedTextInput,
    },
    data() {
        return {
            displayResult: false,
            tab: 'szenario1',
            currency: {},
            topCurrency: {},
            amountOfInvestment: '',
            investmentPeriod: '',
            worstRate: '',
            bestRate: '',
            priceGains: '',
            interestProfit: '',
            totalProfit: '',
            performance: '',
            performanceRate: '',
            priceLoss: '',
            interestLoss: '',
            totalLoss: '',
            performanceLoss: '',
            performanceRateLoss: '',
        };
    },
    mounted() {
        this.getTopCurrency();
        this.calculateRate();
    },
    computed: {
        ...mapState([ 'currencies' ]),
    },
    methods: {
        getTopCurrency() {
            this.currencies.forEach((currency) => {
                if(currency.top) {
                    this.currency = currency;
                }
            });
        },
        calculateRate() {
            let rate = this.currency.currencyRate.rate;
            this.worstRate = rate * 0.8;
            this.bestRate = rate * 1.2;
        },
        onSubmit() {
            this.szenario1();
            this.szenario2();
            this.displayResult = true;
        },
        szenario1() {
            let rate = this.currency.currencyRate.rate;
            let interest = this.currency.currencyRate.interest;
            this.priceGains = (this.amountOfInvestment * rate) / this.worstRate - this.amountOfInvestment;
            this.interestProfit = (((this.amountOfInvestment * rate) * (Math.pow((1 + interest / 1200), this.investmentPeriod))- (this.amountOfInvestment * rate)) / this.worstRate);
            this.totalProfit = parseFloat(this.amountOfInvestment) + parseFloat(this.priceGains) + parseFloat(this.interestProfit);
            this.performance = ((( this.totalProfit - this.amountOfInvestment) / this.amountOfInvestment) * 100);
            this.performanceRate = ((((this.totalProfit - this.amountOfInvestment) / this.amountOfInvestment) / this.investmentPeriod * 12) * 100);
        },
        szenario2() {
            let rate = this.currency.currencyRate.rate;
            let interest = this.currency.currencyRate.interest;
            this.priceLoss = (this.amountOfInvestment * rate) / this.bestRate - this.amountOfInvestment;
            this.interestLoss = (((this.amountOfInvestment * rate) * (Math.pow((1 + interest / 1200), this.investmentPeriod))- (this.amountOfInvestment * rate)) / this.bestRate);
            this.totalLoss = parseFloat(this.amountOfInvestment) + parseFloat(this.priceLoss) + parseFloat(this.interestLoss);
            this.performanceLoss = ((( this.totalLoss - this.amountOfInvestment) / this.amountOfInvestment) * 100);
            this.performanceRateLoss = ((((this.totalLoss - this.amountOfInvestment) / this.amountOfInvestment) / this.investmentPeriod * 12) * 100);
        },
    },

};
